import { IThemeColors } from "ui/theme";

export const themeUtils = {
  getColor: ({ theme: { colors } }: any, colorName: keyof IThemeColors) => (colors as IThemeColors)[colorName],
};
